export const FETCH_SALES_SUBMIT_REQUEST = 'FETCH_SALES_SUBMIT_REQUEST';
export const FETCH_SALES_SUBMIT_SUCCESS = 'FETCH_SALES_SUBMIT_SUCCESS';
export const FETCH_SALES_SUBMIT_FAILURE = 'FETCH_SALES_SUBMIT_FAILURE';

export const DELETE_SALES_SUBMIT = 'DELETE_SALES_SUBMIT';
